export class ChangeUserPasswordModel 
{
    Id: string;
    Password: string;
}